/** This function defines the endpoint used in orval endpoint generation.
 * You can modify this function body as you want,
 *  the only important thing is the function Name,
 *  and it has to return a URL as a string.
 */
export function apiBase() {
    const stored = localStorage.getItem("endpoint");

    if (stored) return stored;
    return import.meta.env.DEV ? "" : "https://api.app.firma-stockner.com";
}
